export enum FilterOption {
    LastYear = '1 year',
    LastSixMonths = '6 months',
    LastThreeMonths = '3 months',
    LastMonth = '1 month',
    LastWeek = '1 week',
    Yesterday = 'Yesterday',
    Today = 'Today',
    Custom = 'Custom'
}